import React from "react";
import { motion } from "framer-motion";
import MyLink from "../hoc/Link/Link";
import scrollTop from "../../assets/images/scrollTop.svg";
import Navigations from "../Common/Navigations/Navigations";
import SocialHandle from "../Common/SocialHandles/SocialHandle";
import ContactMe from "./Contact/Contact";
import BackgroundEffects from "../UI/BackgroundEffects/BackgroundEffects";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={classes.FooterContainer}>
      <BackgroundEffects variant="experience" />

      <div className={classes.SrcollTop}>
        <MyLink to="Navigation">
          <img src={scrollTop} alt="Top" />
        </MyLink>
      </div>

      <motion.div
        className={classes.FooterAbout}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h4 className={classes.FooterSubHeading}>Contact Me</h4>
        <ContactMe />
      </motion.div>

      <motion.div
        className={classes.FooterNavigation}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
        viewport={{ once: true }}
      >
        <h4 className={classes.FooterSubHeading}>Site Map</h4>
        <Navigations CSSstyle={classes.NavCSS} />
      </motion.div>

      <motion.div
        className={classes.FooterSocial}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <h4 className={classes.FooterSubHeading}>Get In Touch!</h4>
        <div className={classes.FooterSocialHandle}>
          <SocialHandle />
        </div>
      </motion.div>
    </div>
  );
};

export default Footer;
